import script from "./system-info-modal.vue?vue&type=script&setup=true&lang=ts"
export * from "./system-info-modal.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__